import { wireframe } from "../lib/themes/lakshmi/lakshmiTheme.css.mjs";
export {
  wireframe as lakshmi
};
